import uniq from 'lodash/uniq';
import { TABS_MAX_LENGTH } from '@utils/constants';
import scrollingWindowFromTo, { setFromToByScrollingMark } from '@utils/scrollingWindowFromTo';

import TabsStorage from './tabsStorage';

const initialTabs = { tabsOrder: [], tabsData: {} };

function TabsManager(key) {
  const ts = new TabsStorage(key);

  const getTabs = (tabs) => {
    let tempTabs = [];
    if (ts.isValid) {
      tempTabs = ts.get() || { ...tabs };
    } else {
      tempTabs = { ...tabs };
    }

    setFromToByScrollingMark(tempTabs);
    for (let i = 0, len = tempTabs.tabsOrder.length; i < len; i += 1) {
      const k = tempTabs.tabsOrder[i];
      tempTabs.tabsData[k] = scrollingWindowFromTo(tempTabs.tabsData[k]);
    }

    return tempTabs;
  };
  const setTabs = ({ tabsOrder, tabsData }) => {
    const tabs = {
      tabsOrder: uniq(tabsOrder.slice(-TABS_MAX_LENGTH)),
      tabsData,
    };
    if (ts.isValid) {
      ts.set(tabs);
    }
    return tabs;
  };

  const parseTabs = (tabs = initialTabs, payload, id, isRemove = false) => {
    const tempTabs = getTabs(tabs);

    if (!payload && !id) return tempTabs;

    const idX = `${id}`;

    let { tabsOrder } = tempTabs;
    let { tabsData } = tempTabs;

    if (isRemove) {
      tabsOrder = tabsOrder.filter(tabId => `${tabId}` !== idX);
      delete tabsData[idX];
    } else if (!tabsOrder.includes(idX)) {
      tabsOrder.push(idX);
      tabsData[idX] = payload;
    } else {
      tabsData[idX] = payload;
    }

    tabsData = { ...tabsData };
    return setTabs({ tabsOrder, tabsData });
  };

  const replaceTab = (tabs = initialTabs, payload, fromId, toId) => {
    const tempTabs = getTabs(tabs);
    const { tabsOrder, tabsData } = tempTabs;

    const fromIdX = `${fromId}`;
    const toIdX = `${toId}`;

    const index = tabsOrder.indexOf(fromIdX);
    if (index > -1) {
      tabsOrder[index] = toIdX;
    }
    delete tabsData[fromIdX];
    tabsData[toIdX] = payload;

    return setTabs({ tabsOrder, tabsData });
  };

  const removeTabs = () => ts.remove();

  return {
    parseTabs,
    replaceTab,
    removeTabs,
  };
}

export default TabsManager;
